var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDragImageIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 104,
    viewBox: "0 0 104 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M87.75 81.9372V88.1562C87.75 91.5218 85.0218 94.25 81.6562 94.25H9.14062C5.77505 94.25 3.04688 91.5218 3.04688 88.1562V28.8438C3.04688 25.4782 5.77505 22.75 9.14062 22.75H15.3467",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M94.8594 81.25H22.3438C18.9782 81.25 16.25 78.5218 16.25 75.1562V15.8438C16.25 12.4782 18.9782 9.75 22.3438 9.75H94.8594C98.225 9.75 100.953 12.4782 100.953 15.8438V75.1562C100.953 78.5218 98.225 81.25 94.8594 81.25Z",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M16.25 63.375L39 45.5L52 56.875L78 34.125L100.953 50.375",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M52 35.75C55.5899 35.75 58.5 32.8399 58.5 29.25C58.5 25.6601 55.5899 22.75 52 22.75C48.4101 22.75 45.5 25.6601 45.5 29.25C45.5 32.8399 48.4101 35.75 52 35.75Z",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDragImageIcon);
export default __webpack_public_path__ + "static/media/drag-image-icon.6a3506c4dc23e049c4af77132f79fb31.svg";
export { ForwardRef as ReactComponent };